import React from 'react';
import CardView from './CardView';
import ListView from './ListView';

const CardContent = props => {
    const { forceCard } = props;
    return (
        <>
            <ListView hideAlways={forceCard} {...props} />
            <CardView showAlways={forceCard} {...props} />
        </>
    );
};

export default CardContent;
